<button data-cy="account-menu-setup_button" (click)="onSetup()" class="item">
  {{ 'menu.setup' | translate }}
</button>
<button data-cy="account-menu-logout_button" (click)="onLogout()" class="item">Logout</button>
